export default "<span class=\"loader\"></span>\n"